import { render } from "./CoordinatorsView.vue?vue&type=template&id=7dd3dd22"
import script from "./CoordinatorsView.vue?vue&type=script&lang=js"
export * from "./CoordinatorsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__